const FloatTypes = {
  Float32: 'float32',
  Float64: 'float64',

  SpacePrecisionType: 'float64'
} as const

export default FloatTypes
